import { SchemaScript } from "@tokenterminal/core/ui/seo/SchemaScript"
import { ORGANIZATION_REF, SITE_URL } from "@tokenterminal/core/ui/seo/SiteSchemas"
import { type ProductId, products } from "@/constants/content"

// A Service, not a SoftwareApplication or Product: Google requires ratings or prices on those, and we have neither
/** JSON-LD for a product page */
export const ProductSchema = ({ id }: { id: ProductId }) => {
  const product = products.find((product) => product.id === id)
  if (!product) return null

  return (
    <SchemaScript
      id="product"
      schema={{
        "@context": "https://schema.org",
        "@type": "Service",
        name: `Token Terminal ${product.name}`,
        description: product.description,
        url: `${SITE_URL}${product.ctaHref}`,
        provider: ORGANIZATION_REF,
      }}
    />
  )
}
